import React from 'react';
import { Box, TableCell, TableRow, Typography } from '@mui/material';
import TimeslotCell from './TimeslotCell';
import { ChannelType, TimeslotEntityRow } from '../types';

interface TimeslotsTableRowProps {
    row: TimeslotEntityRow;
    onSave: (entityId: number, channel: ChannelType, timeslotId: number | null, startHour: string, endHour: string) => Promise<boolean>;
    onRequestReset: (entityId: number, channel: ChannelType, timeslotId: number) => void;
}

const TimeslotsTableRow = ({ row, onSave, onRequestReset }: TimeslotsTableRowProps) => (
    <TableRow hover>
        <TableCell>{row.entity_id}</TableCell>
        <TableCell>{row.entity_identifier}</TableCell>
        <TableCell>
            <Typography variant="body2">{row.entity_name}</Typography>
            <Typography variant="caption" color="text.secondary">{row.city}</Typography>
        </TableCell>
        <TableCell>
            <Box>
                <TimeslotCell
                    entityId={row.entity_id}
                    channel="SMS"
                    timeslot={row.SMS}
                    onSave={onSave}
                    onRequestReset={onRequestReset}
                />
            </Box>
        </TableCell>
        <TableCell>
            <Box>
                <TimeslotCell
                    entityId={row.entity_id}
                    channel="EMAIL"
                    timeslot={row.EMAIL}
                    onSave={onSave}
                    onRequestReset={onRequestReset}
                />
            </Box>
        </TableCell>
    </TableRow>
);

export default TimeslotsTableRow;
